/**
 * 消息中心模块
 */
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const newsCenter = {
	// 获取消息列表
	getNewsList(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.forum}/api/backend/notice/index`,
			header: config.headers,
			data: qs.stringify(data)
		});
	},
	// 添加信息
	addNewsNotice(data) {
		let final = {
			data: JSON.stringify(data)
		};
		return requestByGateway({
			method: 'post',
			url: `${config.api.forum}/api/backend/notice/add`,
			header: config.headers,
			data: qs.stringify(final)
		});
	},
	// 获取消息详情接口
	editNews(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.forum}/api/backend/notice/edit`,
			header: config.headers,
			data: qs.stringify(data)
		});
	},
	// 编辑接口保存
	editSaveNews(data) {
		let final = {
			data: JSON.stringify(data)
		};
		return requestByGateway({
			method: 'post',
			url: `${config.api.forum}/api/backend/notice/update`,
			header: config.headers,
			data: qs.stringify(final)
		});
	},
	// 删除消息
	delNews(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.forum}/api/backend/notice/del`,
			header: config.headers,
			data: qs.stringify(data)
		});
	},
	// 手机预览
	prevNews(data) {
		let final = {
			data: JSON.stringify(data)
		};
		return requestByGateway({
			method: 'post',
			url: `${config.api.forum}/api/backend/notice/prev`,
			header: config.headers,
			data: qs.stringify(final)
		});
	},
	// 发送验证码
	sendCode(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.forum}/api/backend/notice/getCode`,
			header: config.headers,
			data: qs.stringify(data)
		});
	},
	// 获取父节点所有地区信息
	getAllRegions(params) {
		return requestByGateway({
			method: 'GET',
			url: `${
				config.api.schoolstruct
			}/SchoolStruct/AdministrativeDivision/getAllRegions`,
			header: config.headers,
			params
		});
	},
	// 区域id获取学校列表
	getSchoolsByDistrict(params) {
		return requestByGateway({
			method: 'GET',
			url: `${
				config.api.schoolstruct
			}/SchoolStruct/School/getSchoolsByDistrict`,
			header: config.headers,
			params
		});
	},
	// 导出excel名单
	getExportFile(data) {
		console.log('导出excel名单:' + data);
		return requestByGateway({
			method: 'POST',
			url: `${config.api.forum}/api/backend/notice/assignExport`,
			header: config.headers,
			data: qs.stringify(data)
		});
	},
	// 查看excel名单列表
	getExportList(data) {
		console.log('查看excel名单列表:' + data);
		return requestByGateway({
			method: 'POST',
			url: `${config.api.forum}/api/backend/notice/exportList`,
			header: config.headers,
			data: qs.stringify(data)
		});
	},
	// 获取统计人数
	getSendTotal(data) {
		let final = {
			data: JSON.stringify(data)
		};
		return requestByGateway({
			method: 'POST',
			url: `${config.api.forum}/api/backend/notice/areaSendCount`,
			header: config.headers,
			data: qs.stringify(final)
		});
	}
};
export default newsCenter;
